import { render, staticRenderFns } from "./BankDocumentPreview.vue?vue&type=template&id=25c1944b&scoped=true&"
import script from "./BankDocumentPreview.vue?vue&type=script&lang=js&"
export * from "./BankDocumentPreview.vue?vue&type=script&lang=js&"
import style0 from "./BankDocumentPreview.vue?vue&type=style&index=0&id=25c1944b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c1944b",
  null
  
)

export default component.exports